<template>
  <div ref="testAlertList">
    <v-alert
      v-for="(alert, alertIndex) in alerts"
      :type="alert.status"
      :dismissible="alert.dismissible"
      dense
      :key="'alert' + alertIndex"
    >
      {{ alert.message }}
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Alerts',
  props: {
    module: {
      type: String,
      default: ''
    },
    alertGroup: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    clearAlertsMutation: function () {
      return this.module ? this.module + '/clearAlerts' : 'clearAlerts';
    },
    ...mapState({
      alerts: function (state) {
        if (this.module) {
          return state[this.module].alerts[this.alertGroup];
        }
        return state.alerts[this.alertGroup];
      }
    })
  },
  created: function () {
    this.$store.commit(this.clearAlertsMutation, this.alertGroup);
  }
};
</script>
